import { useEffect } from "react";
import { useLanguage } from "@/i18n";

const descriptions = {
  english: "PT Samudera Berkah Firdaus provides integrated Indonesian shipping, freight charter, trucking, port handling, and logistics services.",
  indonesia: "PT Samudera Berkah Firdaus menyediakan layanan pelayaran, freight charter, trucking, penanganan pelabuhan, dan logistik terintegrasi di Indonesia.",
};

export default function Seo({ title, path }) {
  const { language } = useLanguage();
  useEffect(() => {
    const description = descriptions[language];
    document.documentElement.lang = language === "indonesia" ? "id" : "en";
    document.title = `${title} | PT Samudera Berkah Firdaus`;
    document.querySelector('meta[name="description"]')?.setAttribute("content", description);
    document.querySelector('link[rel="canonical"]')?.setAttribute("href", `https://www.samuderaberkahfirdaus.com${path}`);
    const ogTitle = document.querySelector('meta[property="og:title"]'); if (ogTitle) ogTitle.content = document.title;
    const ogDescription = document.querySelector('meta[property="og:description"]'); if (ogDescription) ogDescription.content = description;
  }, [language, path, title]);
  return null;
}